import Messages from "./Messages";
import MessageForm from "./MessageForm";
import { useAppIssueContext } from "../context/appIssueContext";
import IssueForm from "./IssueForm";
import { AppContextProvider } from "../context/appContext";

export default function ChatCollapse() {
  const { loadingInitial, error, getIssuesAndSubscribe, issues } = useAppIssueContext();

  if (loadingInitial)
    return (
      <div>
        <div />
      </div>
    );
  if (error)
    return (
      <div status="error" mt="20px">
        {error}
        <button ml="5px" onClick={getIssuesAndSubscribe} colorScheme="red" variant="link">
          try to reconnect
        </button>
      </div>
    );

  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card-body">
          <IssueForm />
        </div>

        {!issues.length && <div as="h3">No issues 🙂</div>}

        {issues.map((issue) => (
          <div key={issue.id} className="accordion accordion-alterate arrow-right" id={`topic_${issue.id}`}>
            <div className="card">
              <div className="card-header" id={`heading_${issue.id}`}>
                <h5 className="mb-0">
                  <a
                    href="#"
                    className="collapsed"
                    data-toggle="collapse"
                    data-target={`#collapse_${issue.id}`}
                    aria-expanded="false"
                    aria-controls={`collapse_${issue.id}`}
                    dangerouslySetInnerHTML={{ __html: issue.title }}
                  ></a>
                </h5>
              </div>
              <AppContextProvider issue_id={issue.id}>
                <div
                  id={`collapse_${issue.id}`}
                  className="collapse"
                  aria-labelledby={`heading_${issue.id}`}
                  data-parent={`#topic_${issue.id}`}
                >
                  <p style={{ color: "black" }} dangerouslySetInnerHTML={{ __html: issue.text }}></p>
                  <div className="card-body">
                    <Messages issue_id={issue.id} />
                  </div>
                  <div className="card-body">
                    <MessageForm issue_id={issue.id} />
                  </div>
                </div>
              </AppContextProvider>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
